import types from "../actions/actionTypes";
import initialState from "./initialState";

export default function engineerReportsReducer(state = initialState.engineerReports, action) {

    const mergeIn = (engineerReports, update) => {
        const engineerReportsMinusStaleData = engineerReports.filter(p => p.startMonth !== update.startMonth
            && p.timeFrame !== update.timeFrame);
        return engineerReportsMinusStaleData.concat(update);
    }

    const setUpdateRequired = engineerReports => {     
        return engineerReports.map(er => {    
           return { ...er,requiresUpdate: true };      
        });  
    }


    switch (action.type) {
        case types.LOAD_ENGINEER_REPORTS_SUCCESS:
            return mergeIn(state, action.reportData);
        case types.DELETED_PHASE:
        case types.UPDATED_PHASE_INCOMING:
        case types.UPDATED_PHASE_SUCCESS:
        case types.DELETED_PHASE_INCOMING:
        case types.DELETED_PROJECTITEM:
        case types.DELETED_PROJECTITEM_INCOMING:
        case types.UPDATED_PROJECTITEM_INCOMING:
        case types.UPDATED_PROJECTITEM_SUCCESS:
        case types.DELETED_PROJECTITEMACTIVITY:
        case types.DELETED_PROJECTITEMACTIVITY_INCOMING:
        case types.UPDATED_PROJECTITEMACTIVITY_INCOMING:
        case types.UPDATED_PROJECTITEMACTIVITY_SUCCESS:
        case types.DELETED_USER:
        case types.DELETED_USER_INCOMING:
        case types.UPDATED_USER_INCOMING:
        case types.UPDATED_USER_SUCCESS:
            return setUpdateRequired(state);
        default:
            return state;
    }
}